/**
 * Implementation of `DirectoryContainerViewBase` where the root directory is actually a set of `Layer` models.
 *
 * ## Fields
 * Name | Description
 * --- | ---
 * models | The array of `FormResponse` models associated with this view.
 * fields | The array of `Field` models specifying the fields to display at the root level.
 * view | The `WindowView` associated with this interface.
 * featureLayer | The `Layer` associated with this interface.
 * @module app/views/map/ModelDirectoryView
 * @extends {DirectoryContainerViewBase}
 */
import DirectoryContainerViewBase from "app/views/DirectoryContainerViewBase";
import _ from "underscore";
import $ from "jquery";
import Field from "core/models/Field";
import CollectionTableView from "core/views/CollectionTableView";
import ButtonView from "core/views/ButtonView";
import Backbone from "backbone";
import auth from "app/auth";
import Feature from "app/models/Feature";
import WindowView from "core/views/WindowView";
import urlService from "app/UrlService";
export default DirectoryContainerViewBase.extend(
  {
    initialize: function (options) {
      var opts = _.extend({}, options, {
        initialFolder: true,
        allowAddFiles: false,
        allowAddFolder: false,
      });

      DirectoryContainerViewBase.prototype.initialize.call(this, opts);
      this.models = options.models || [];
      this.fields = options.fields || [];
      this.featureLayer = options.featureLayer;
    },

    className: "model-directory-view",

    events: _.extend({}, DirectoryContainerViewBase.prototype.events, {
      "click .response-link": function (evt) {
        evt.preventDefault();
        this.navigateTo($(evt.target).data("feature"), "Files");
      },
    }),

    render: function (viewOptions) {
      var view = (this.view = WindowView.create(
        this.options.title,
        _.extend({}, this.options, {})
      ));

      if (viewOptions) {
        view.size(viewOptions);
      }

      var fields = this.fields.slice();
      var self = this;

      this._links = [];

      fields.unshift(
        new Field({
          id: "id",
          name: "id",
          label: "",
          editor: "custom",
          ViewerView: {
            template: _.template(
              '<a href="<%-url%>" class="response-link" data-feature="<%-value%>"><%-text%></a>'
            ),

            serialize: function (options) {
              return {
                url: "#",
                value: options.value,
                text: "View Files",
              };
            },

            getControlValue: function () {
              return this.$("a").data("feature");
            },

            setControlValue: function () {
              this.render();
            },
          },
        })
      );

      view.$el.on("click", ".response-link", function (evt) {
        evt.preventDefault();
        var featureId = $(evt.target).data("feature");

        if (featureId) {
          self.navigateTo(Feature.getDocumentsUrl(featureId), "Files");
        }
      });

      var tableView = (this._root = new CollectionTableView({
        fields: fields,
        collection: this.models,
        allowSave: false,
        allowDelete: false,
        mode: "view",
      }));

      var upButton = (this._up = new ButtonView({
        text: "Up",
        click: function () {
          self.navigateUp();
        },
      }));

      upButton.render();
      view.header.getRightControlBar().prepend(upButton.$el);
      upButton.$el.hide();

      tableView.render();
      view.setContent(tableView.$el);
      view.show();
      view.center();
      this.doneRendering();
    },

    navigateTo: function (dirUrl, heading) {
      if (dirUrl !== true) {
        return DirectoryContainerViewBase.prototype.navigateTo.apply(
          this,
          arguments
        );
      } else {
        this.directories.push(this._root);
        this.headings.push(this.view.header.getTitle());
        this.atRoot();
        this.setView(this._root);
      }
    },

    leftRoot: function () {
      this._up.$el.show();
    },

    atRoot: function () {
      _.each(this._links, function (link) {
        link.delegateEvents();
      });
      this.delegateEvents();
      this._up.$el.hide();
    },

    setHeading: function (heading) {
      this.view.header.setTitle(heading);
    },

    setView: function (directory) {
      this.view.setContent(directory.$el);
    },

    getFolderUrl: function (folderModel) {
      return folderModel.getChildrenUrl();
    },

    getFolderName: function (folderModel) {
      return folderModel.get("Name");
    },

    fileUrl: function (fileModel) {
      return fileModel.getFilePath(auth.token);
    },
  },
  {
    ViewFilesLink: Backbone.View.extend({
      tagName: "a",
      attributes: {
        href: "#",
      },

      events: {
        click: function (evt) {
          evt.preventDefault();
          this.trigger("click");
        },
      },

      render: function () {
        this.$el.html("View Files");
      },
    }),
  }
);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/ModelDirectoryView.js
// module id = 493
// module chunks = 1